import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { COMMON_IMPORTS } from '../../../global-misc/common-imports';

@Component({
    selector: 'app-reset-password-dialog',
    imports: [...COMMON_IMPORTS, DialogModule],
    templateUrl: './reset-password-dialog.component.html',
    styleUrls: ['./reset-password-dialog.component.css']
})
export class ResetPasswordDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<void>();

  onClose() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onCancel() {
    this.onClose();
  }

  onConfirm() {
    this.confirm.emit();
    this.onClose();
  }
}
